import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";

const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/SecondaryHero")
);

const SecondaryHeroEditConfig = {
  emptyLabel: "Secondary Hero",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => ({
  component: "SecondaryHero",
  props: {
    slideSpeed: props.carouselTiming,
    theme: props.theme,
    slides: props.slides.map((slide) => ({
      height: window && window.CQ ? "600px" : undefined,
      media: slide.media,
      heading: slide.heading,
      headingSize: slide.typographySize,
      subHeading: slide.subHeading,
      logo: slide.logo
        ? {
            desktop: {
              type: "desktop",
              src: slide.logo?.src,
              alt: slide.logo?.altText,
            },
          }
        : undefined,
      svgColor: slide.logo?.color,
      svgMarkup: slide.logo?.markup,
      onAssetTextColor: slide.fontColorOnAsset,
      offAssetTextColor: slide.fontColorOffAsset,
      horizontalPosition: slide.textHorizontalPosition,
      horizontalPositionMobile: slide.textHorizontalPositionMobile,
      verticalPosition: slide.textVerticalPosition,
      verticalPositionMobile: slide.textVerticalPositionMobile,
      copyOnMobileAsset: slide.mobileCopyOrientation,
      ctas: slide.ctas,
    })),
  },
});

const SecondaryHero = (props) => {
  const data = transformData(props);
  return <Component {...data.props} />;
};

export default withAemIntegration("lexus/components/secondary-hero")(
  SecondaryHero,
  SecondaryHeroEditConfig
);
